import { createClient } from "@supabase/supabase-js";

// Replace with your Supabase Project URL and Anon Key
const SUPABASE_URL = "https://ojzugvbvdnzgwjcgpyil.supabase.co";
const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9qenVndmJ2ZG56Z3dqY2dweWlsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMwMzYxNTEsImV4cCI6MjA2ODYxMjE1MX0.6ypqYQldBjWyZ_rLlGdebrW9E0KF1YwuF6rrlLetpEc";

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export default supabase;
